var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPnkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 896.076,
    height: 810,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#45464D",
    d: "M684.785 62.012 279.391 43.92 43.353 338.768l165.393 394.044 409.449 24.789 233.071-331.488z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#656569",
    d: "M851.266 426.527 620.33 192.34l-60.738 449.244z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 200.71,
    y1: 416.962,
    x2: 620.33,
    y2: 416.962
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a3a2a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    style: {
      stopColor: "#9f9ea0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    style: {
      stopColor: "#929194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    style: {
      stopColor: "#7c7c80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#707073"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M200.71 373.854 620.33 192.34l-60.738 449.244z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 197.935,
    y1: 367.832,
    x2: 496.087,
    y2: 72.558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#969598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#908f92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    style: {
      stopColor: "#7f7f82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#757578"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M620.33 192.34 279.391 44.335 200.71 373.854z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 220.916,
    y1: 363.666,
    x2: 380.185,
    y2: 679.506
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9e9ea0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    style: {
      stopColor: "#9b9b9d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    style: {
      stopColor: "#919194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    style: {
      stopColor: "#808083"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    style: {
      stopColor: "#69696d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55565a"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m200.71 373.854 8.036 359.374 350.846-91.644z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#757578",
    d: "m620.33 192.34 64.455-129.913-405.394-18.092z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6D70",
    d: "m684.785 62.427 166.481 364.1L620.33 192.34z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6D70",
    d: "M851.266 426.527 618.195 758.015l-58.603-116.431z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#55565A",
    d: "m618.195 758.015-409.449-24.787 350.846-91.644zM279.391 44.335 43.353 339.182l157.357 34.672z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#656569",
    d: "m43.353 339.182 165.393 394.046-8.036-359.374z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#151A22",
    d: "m577.386 254.212-42.532 322.065-250.678-193.903zM543.44 189.992 309.117 89.053 259.895 301.28z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#23262E",
    d: "M484.048 625.068 229.384 443.142l6.159 246.518zM808.476 425.723 634.935 249.55l-45.806 338.776z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#43444B",
    d: "m543.756 664.691 37.799 72.343-252.576-16.18z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#34363D",
    d: "M774.56 505.654 586.556 645.771l37.357 73.038zM685.632 113.299l99.403 213.221-135.917-138.225z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#36383F",
    d: "m640.137 77.41-41.798 76.462L401.46 67.719z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#3B3C43",
    d: "M245.925 112.093 190.52 346.971 78.747 323.285z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#45464D",
    d: "m183.779 388.397 4.877 252.411L71.468 364.609z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnkLogo);
export default __webpack_public_path__ + "static/media/pnk-logo.f8b36e913bb85987f0bb39aaacec4473.svg";
export { ForwardRef as ReactComponent };